import React from 'react';

/* Los datos también se tienen que actualizar solos.

   Cada pantalla pide sus datos una vez, cuando se monta. En el navegador eso
   alcanza porque se recarga seguido, pero una app instalada en el celular queda
   abierta durante días: el cliente la abría y veía las facturas de la semana
   pasada, sin enterarse de que había algo nuevo.

   Refrescar de verdad es volver a montar el árbol de pantallas: cada una ya sabe
   cargarse sola al montarse, así que cambiar la llave las recarga a todas sin
   tener que tocar ninguna.

   Lo delicado es CUÁNDO. Un remontaje te devuelve al principio de la pantalla y
   te vacía lo que estabas escribiendo, así que nunca se hace por encima de
   alguien que está usando la app: ni escribiendo, ni con un modal abierto, ni
   leyendo algo hace un rato. */

const VOLVIO = 45 * 1000;          // guardada más que esto, al volver se refresca
const CADA = 3 * 60 * 1000;        // y cada tanto, si nadie está tocando nada
const QUIETO = 60 * 1000;          // "nadie está tocando nada" es esto

/* No pisar a alguien que está trabajando. Un formulario a medio llenar o un
   modal abierto valen más que tener el dato del minuto. */
export function estaOcupado() {
  if (document.querySelector('.modal-overlay')) return true;
  const f = document.activeElement;
  return !!f && /^(INPUT|TEXTAREA|SELECT)$/.test(f.tagName);
}

export function useRefrescoDeDatos() {
  const [llave, setLlave] = React.useState(0);
  const oculta = React.useRef(0);
  const tocado = React.useRef(Date.now());

  React.useEffect(() => {
    const refrescar = () => { if (!estaOcupado()) setLlave(v => v + 1); };
    const marcar = () => { tocado.current = Date.now(); };

    const alVolver = () => {
      if (document.hidden) { oculta.current = Date.now(); return; }
      const dormida = oculta.current ? Date.now() - oculta.current : 0;
      oculta.current = 0;
      tocado.current = Date.now();
      if (dormida >= VOLVIO) refrescar();
    };

    /* Cuando llega un aviso por push —una minuta publicada, un cobro nuevo, un
       reporte— el service worker nos avisa y la pantalla se pone al día en el
       acto, sin esperar al próximo repaso. Esto es lo más cerca del tiempo real
       que se puede estar sin dejar una conexión abierta todo el día. */
    const alAvisar = (e) => { if (e.data?.tipo === 'datos-nuevos') refrescar(); };

    const reloj = setInterval(() => {
      if (document.hidden) return;
      if (Date.now() - tocado.current < QUIETO) return;   // la está usando: no molestar
      refrescar();
    }, CADA);

    document.addEventListener('visibilitychange', alVolver);
    window.addEventListener('pageshow', alVolver);
    window.addEventListener('focus', alVolver);
    window.addEventListener('online', refrescar);
    ['pointerdown', 'keydown', 'scroll'].forEach(ev =>
      window.addEventListener(ev, marcar, { passive: true }));
    navigator.serviceWorker?.addEventListener('message', alAvisar);

    return () => {
      clearInterval(reloj);
      document.removeEventListener('visibilitychange', alVolver);
      window.removeEventListener('pageshow', alVolver);
      window.removeEventListener('focus', alVolver);
      window.removeEventListener('online', refrescar);
      ['pointerdown', 'keydown', 'scroll'].forEach(ev => window.removeEventListener(ev, marcar));
      navigator.serviceWorker?.removeEventListener('message', alAvisar);
    };
  }, []);

  return llave;
}
